import { getAggregataForTicketResearch } from '../../redux/actions/ticketActions';
import { useDispatch, useSelector } from 'react-redux';
import  RelevantArticles  from './RelevantArticles.jsx';
import { Box, Skeleton, Stack } from '@mui/material';
import SimilarTickets  from './SimilarTickets.jsx';
import React, { useEffect } from 'react';
import  Workflows  from './Workflows.jsx';

const TicketResearch = ({ subDomain, ticketingSystem, prismToken, ticketId, orgId, agentDetails, userEmail, ticketDetails }) => {
    const dispatch = useDispatch();
    const { similarTickets, relevantArticles, articlesloading: isRelevantArticlesLoading, researchTabloading: isResearchLoading, workflowsLoading, workflows } = useSelector((state) => state.ticket);
    const { buttonLabels, loading, articleResponses } = useSelector((state) => state.article);

    useEffect(() => {
        dispatch(getAggregataForTicketResearch(ticketDetails, agentDetails, userEmail, prismToken, orgId));
    }, [ticketDetails, agentDetails, userEmail, prismToken, ticketId, orgId, dispatch]);

    const queryText = ticketDetails?.question ?? ticketDetails?.subject;

    return (
        <Box padding={1} sx={{ overflowY: 'auto', maxHeight: '100%' }}>
            {workflowsLoading ? (
                <Box mb={3}>
                    <Stack spacing={1}>
                        <Skeleton variant="text" width="30%" />
                        <Skeleton variant="rectangular" height={60} />
                        <Skeleton variant="rectangular" height={60} />
                    </Stack>
                </Box>
            ) : (
                <Workflows workflows={workflows} isloading={workflowsLoading} userEmail={userEmail} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} renderType="ticket" subDomain={subDomain} ticketingSystem={ticketingSystem} agentDetails={agentDetails} queryText={queryText} />
            )}

            {isRelevantArticlesLoading ? (
                <Box mb={3}>
                    <Stack spacing={1}>
                        <Skeleton variant="text" width="40%" />
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="90%" />
                        <Stack direction="row" spacing={1}>
                            <Skeleton variant="rectangular" width={100} height={36} />
                            <Skeleton variant="rectangular" width={100} height={36} />
                        </Stack>
                    </Stack>
                </Box>
            ) : (
                <RelevantArticles relevantArticles={relevantArticles} articleResponses={articleResponses} isLoading={isRelevantArticlesLoading} buttonLabels={buttonLabels} loading={loading} renderType="ticket" prismToken={prismToken} orgId={orgId} queryText={queryText} ticketDetails={ticketDetails} userEmail={userEmail} ticketingSystem={ticketingSystem} subDomain={subDomain} agentDetails={agentDetails} />
            )}

            {!similarTickets ? (
                <Box mb={3}>
                    <Stack spacing={2}>
                        {[1, 2, 3].map((item) => (
                            <Stack direction="row" spacing={2} alignItems="center" key={item}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Stack spacing={0.5} width="100%">
                                    <Skeleton variant="text" width="60%" />
                                    <Skeleton variant="text" width="40%" />
                                </Stack>
                            </Stack>
                        ))}
                    </Stack>
                </Box>
            ) : (
                <SimilarTickets similarTickets={similarTickets} userEmail={userEmail} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} renderType="ticket" agentDetails={agentDetails} ticketingSystem={ticketingSystem} subDomain={subDomain} queryText={queryText} />
            )}
        </Box>
    );
};

export default TicketResearch;